import lang from "@/views/modules/BudgetSubHeads/language/en";

let searchFieldsDef = {
    'name': {
        label: lang.LBL_SUBHEAD_NAME,
    },
    'name__bh': {
        label: lang.LBL_HEAD_NAME,
        relRef:'budgetsubheads_budgetheads'
    },
    'sequence_no': {
        label: lang.LBL_SEQUENCE_NO,
    },
    'status': {
        label: lang.LBL_STATUS,
        type:'select',
        field_infos:'status'
    },
};
export default { searchFieldsDef }